import { FederatedMouseEvent } from './FederatedMouseEvent.mjs';

class FederatedWheelEvent extends FederatedMouseEvent {
  constructor() {
    super(...arguments);
    this.DOM_DELTA_LINE = 0;
    this.DOM_DELTA_PAGE = 1;
    this.DOM_DELTA_PIXEL = 2;
  }
}

export { FederatedWheelEvent };
//# sourceMappingURL=FederatedWheelEvent.mjs.map
